import api from './api';
import type { Notification as NotificationType, PaginatedResponse } from '../types';

interface UnreadCountResponse {
  unread_count: number;
}

interface MarkAllReadResponse {
  updated_count: number;
}

export const notificationsApi = {
  getNotifications(params?: { page?: number; is_read?: string; type?: string }) {
    return api.get<PaginatedResponse<NotificationType>>('/notifications/', { params });
  },

  getUnreadCount() {
    return api.get<UnreadCountResponse>('/notifications/unread-count/');
  },

  markAsRead(id: string) {
    return api.patch<NotificationType>(`/notifications/${id}/read/`);
  },

  markAllAsRead() {
    return api.post<MarkAllReadResponse>('/notifications/mark-all-read/');
  },

  deleteNotification(id: string) {
    return api.delete(`/notifications/${id}/`);
  },
};
